import { GridFilterModel } from "@mui/x-data-grid-pro";
import { GridFilterItem, GridLinkOperator } from "@mui/x-data-grid-pro";
import { snakeCase } from "lodash";
import { operators, operatorsThatRequireValue } from "components/DataGrid/helpers/operators";

function escapeSpecialCharacters(value: string | number, escapeWhitespace: boolean) {
  // + - = && || > < ! ( ) { } [ ] ^ " ~ * ? : \ /
  const escapedValue = value.toString().replaceAll(/([+\-=&|><!(){}\[\]^"~*?:\\/])/g, "\\$1");
  if (escapeWhitespace) return escapedValue.replaceAll(/\s+/g, "\\ ");
  return escapedValue;
}

function removeRequiredItemsWithEmptyValue(item: GridFilterItem) {
  if (operatorsThatRequireValue.includes(item.operatorValue || "")) {
    return item.value !== undefined && item.value.toString().trim().length !== 0;
  }

  return true;
}

export function filterItemToQueryString(item: GridFilterItem) {
  const fieldName = snakeCase(item.columnField);
  const operator = operators.find((op) => op.operatorValue === item.operatorValue);
  if (!operator) return "";
  if (operator.multiValue) {
    return `${fieldName}:${operator.serializer(item.value.map((v: string) => escapeSpecialCharacters(v, operator.escapeWhitespace)))}`;
  } else {
    return `${fieldName}:${operator.serializer(escapeSpecialCharacters(item.value ?? "", operator.escapeWhitespace))}`;
  }
}

function quickFilterValuesToQueryString(values: string[]) {
  if (values.length === 0) return undefined;

  const filterValueString = values.join(" ");

  // We want to escape whitespace if there is a label ID
  if (!!filterValueString.match(/ - /)) {
    return `(*${escapeSpecialCharacters(filterValueString, true)}*)`;
  } else {
    let result = escapeSpecialCharacters(filterValueString, false);
    result = result
      .split(/AND/)
      .map((part) => `*${part.trim()}*`)
      .join(" AND ");
    return `(${result})`;
  }
}

export function filterModelToElasticQueryString(filterModel: GridFilterModel): string {
  const itemFilters = filterModel.items.filter(removeRequiredItemsWithEmptyValue).map(filterItemToQueryString);

  const quickFilters = quickFilterValuesToQueryString(filterModel.quickFilterValues || []);
  return [...itemFilters, quickFilters]
    .filter((v) => v?.length)
    .join(filterModel.linkOperator === GridLinkOperator.And ? " AND " : " OR ");
}
